// @ts-nocheck
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import moment from "moment-timezone";
import { setEditHistory } from "./TableCopyData/slices";

export const stateRecordData = createSlice({
  name: "stateRecordData",
  initialState: {
    body: [],
    prevLength: 0,
    headKeyView: [],
    headsView: {},
    data: null,
    startIndex: 0,
    startHeadIndex: 0,
    pageNumber: 1,
    widths: {},
    multiCopyData: [],
    multiCopyDataValues: [],
    dbConnectId: null,
    comment: [],
    recordViewItem: [],
    currentSelectPosition: [],
    multiSelectRow: 0,
    multiSelectCol: 0,
    isApi: false,
    aggregateResults: {},
    databaseInfo: {},
    footerHeadsView: {},
  },
  reducers: {
    setDatabaseInfo: (state, action) => {
      state.databaseInfo = { ...action.payload };
    },
    insertConnectId: (state, action) => {
      state.dbConnectId = action.payload.id;
    },
    insertWidths: (state, action) => {
      state.widths = action.payload.widths;
    },
    updateWidths: (state, action) => {
      state.widths[action.payload.key] = action.payload.width;
    },
    insertData: (state, action) => {
      state.data = action.payload.data;
    },
    insertBody: (state, action) => {
      state.body = action.payload.body;
    },
    addBody: (state, action) => {
      // NOTE: 重複したデータを追加しないようにしている
      const addRecordId = action.payload[0]?.id;
      if (state.body.some((item: any) => item.id === addRecordId)) {
        return;
      }
      state.body = [...state.body, ...action.payload];
    },
    setHeadKeyView: (state, action) => {
      state.headKeyView = action.payload.headKeys;
    },
    setHeadsView: (state, action) => {
      state.headsView = action.payload.heads;
    },
    setStartIndex: (state, action) => {
      state.startIndex = action.payload.index;
    },
    setStartHeadIndex: (state, action) => {
      state.startHeadIndex = action.payload.index;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload.number;
    },
    insertRecords: (state, action) => {
      for (const i in state.body) {
        state.body[i].records = action.payload.records[i];
      }
    },
    setCurrentSelectPosition: (state, action) => {
      state.currentSelectPosition = action.payload.position;
    },
    stateMultiCopyData: (state, action) => {
      state.multiCopyData = action.payload.data;
    },
    stateMultiCopyDataValues: (state, action) => {
      state.multiCopyDataValues = action.payload.values;
    },
    insertReturnValue: (state, action) => {
      const record = state.body[action.payload.i - state.prevLength];

      if (record) {
        for (const [key, value] of Object.entries(state.body[action.payload.i - state.prevLength]["records"])) {
          for (const k of Object.keys(action.payload.records)) {
            if (k === key && ["formula", "updated_at"].includes(action.payload["records"][key].type)) {
              state.body[action.payload.i - state.prevLength]["records"][key].value =
                action.payload["records"][key].value;
              break;
            }
          }
        }
      }
    },
    insertMultiFormula: (state, action) => {
      if (state.body[action.payload.i - state.prevLength]?.records) {
        for (const [key, data] of Object.entries(state.body[action.payload.i - state.prevLength]["records"])) {
          if (key === action.payload.id && action.payload["records"][key].type === "formula") {
            state.body[action.payload.i - state.prevLength]["records"][key].value = action.payload.val.value;
            break;
          }
        }
      }
    },
    updateValue: (state, action) => {
      if (state.body[action.payload.i - state.prevLength]?.records) {
        for (const [key, data] of Object.entries(state.body[action.payload.i - state.prevLength]["records"])) {
          if (key === action.payload.id) {
            if (state.body[action.payload.i - state.prevLength]["records"][key].type === "date") {
              state.body[action.payload.i - state.prevLength]["records"][key].value = action.payload.val
                ? moment.tz(action.payload.val, action.payload.timeZone).format()
                : null;
            } else if (state.body[action.payload.i - state.prevLength]["records"][key].type === "datetime") {
              state.body[action.payload.i - state.prevLength]["records"][key].value = action.payload.val
                ? moment.tz(action.payload.val, action.payload.timeZone).format()
                : null;
            } else if (
              state.body[action.payload.i - state.prevLength]["records"][key].type === "file" ||
              state.body[action.payload.i - state.prevLength]["records"][key].type === "image"
            ) {
              if (state.body[action.payload.i - state.prevLength]["records"][key].value?.length) {
                state.body[action.payload.i - state.prevLength]["records"][key].value.push(action.payload.val);
              } else {
                state.body[action.payload.i - state.prevLength]["records"][key].value = [action.payload.val];
              }
            } else if (state.body[action.payload.i - state.prevLength]["records"][key].type === "link") {
              state.body[action.payload.i - state.prevLength]["records"][key].value = action.payload.val;
            } else {
              state.body[action.payload.i - state.prevLength]["records"][key].value = action.payload.val;
            }
          }
        }
      }
    },
    // NOTE: レコード詳細モーダルのみで呼ばれるメソッド。後々updateValueが呼ばれている箇所を全てこのメソッドに置き換える。
    updateValueFromModal: (state, action) => {
      const { val, columnId, recordId } = action.payload;
      const targetRecord = state.body.find((record) => record.id === recordId);

      if (targetRecord?.records && targetRecord.records[columnId]) {
        const dataType = targetRecord.records[columnId].type;

        switch (dataType) {
          case "date":
          case "datetime":
            targetRecord.records[columnId].value = val
              ? moment.tz(action.payload.val, action.payload.timeZone).format()
              : null;
            break;
          case "file":
          case "image":
            if (targetRecord.records[columnId].value?.length) {
              targetRecord.records[columnId].value.push(val);
            } else {
              targetRecord.records[columnId].value = [val];
            }
            break;
          default:
            targetRecord.records[columnId].value = val;
        }
      }
    },
    insertComment: (state, action) => {
      state.comment = action.payload;
    },
    deleteFileValue: (state, action) => {
      if (state.body[action.payload.i - state.prevLength]?.records) {
        for (const [key, data] of Object.entries(state.body[action.payload.i - state.prevLength]["records"])) {
          if (state.body[action.payload.i - state.prevLength]["records"][key].type === "file") {
            if (state.body[action.payload.i - state.prevLength]["records"][key].value?.length) {
              const tempValue = state.body[action.payload.i - state.prevLength]["records"][key].value.filter(
                (n) => n.id !== action.payload.val,
              );
              state.body[action.payload.i - state.prevLength]["records"][key].value = tempValue;
            } else {
              state.body[action.payload.i - state.prevLength]["records"][key].value = [];
            }
          }
        }
      }
    },
    deleteImageValue: (state, action) => {
      if (state.body[action.payload.i - state.prevLength]?.records) {
        for (const [key, data] of Object.entries(state.body[action.payload.i - state.prevLength]["records"])) {
          if (state.body[action.payload.i - state.prevLength]["records"][key].type === "image") {
            if (state.body[action.payload.i - state.prevLength]["records"][key].value?.length) {
              const tempValue = state.body[action.payload.i - state.prevLength]["records"][key].value.filter(
                (n) => n.id !== action.payload.val,
              );
              state.body[action.payload.i - state.prevLength]["records"][key].value = tempValue;
            } else {
              state.body[action.payload.i - state.prevLength]["records"][key].value = [];
            }
          }
        }
      }
    },
    stateMultiSelect: (state, action) => {
      state.multiSelectRow = action.payload.row;
      state.multiSelectCol = action.payload.col;
    },
    statePrevLength: (state, action) => {
      state.prevLength = action.payload.length;
    },
    setIsApi: (state, action) => {
      state.isApi = action.payload.flag;
    },
    setAggregateResults: (state, action) => {
      state.aggregateResults = Object.assign({}, state.aggregateResults, action.payload);
    },
    setFooterHeadsView: (state, action) => {
      state.footerHeadsView = action.payload;
    },
  },
});

export const {
  insertData,
  insertBody,
  addBody,
  setHeadKeyView,
  updateValue,
  insertWidths,
  updateWidths,
  insertConnectId,
  insertReturnValue,
  insertComment,
  stateMultiCopyData,
  insertMultiFormula,
  deleteFileValue,
  deleteImageValue,
  concatBody,
  setStartIndex,
  setStartHeadIndex,
  setHeadsView,
  insertRecords,
  setCurrentSelectPosition,
  stateMultiSelect,
  stateMultiCopyDataValues,
  statePrevLength,
  setIsApi,
  setAggregateResults,
  setDatabaseInfo,
  setFooterHeadsView,
  updateValueFromModal,
} = stateRecordData.actions;

export const updateField =
  (i, body, record, value, key = null, heads, pathname, timeZone) =>
  async (dispatch, getState) => {
    const { footerHeadsView } = getState().stateRecordData;
    const attributes = {};
    if (record.type === "check_box") {
      const data = [];
      heads[key].selections.forEach((v) => {
        data.push(v.name);
      });
      value = value ? value.filter((i) => data.includes(i)) : value;
    } else if (record.type === "date" || record.type === "datetime") {
      value = value ? moment.tz(value, timeZone) : "";
    }

    if (record.type === "member" && value) {
      attributes[heads[key].data_position] = value.map((value) => value.id);
    } else {
      attributes[heads[key].data_position] = value;
    }

    dispatch(
      updateValue({
        i: i,
        val: value,
        id: key,
        timeZone: timeZone,
      }),
    );
    const formulaColumnIds = [];
    const { data } = await axios.patch(`${pathname}/dynamic_table_records/batch_update`, {
      dynamic_table_records: [
        {
          id: body.id,
          attributes,
        },
      ],
    });
    if (data.body[0]) {
      dispatch(
        insertReturnValue({
          records: data.body[0].records,
          i: i,
          id: key,
        }),
      );
      Object.keys(data.body[0].records).forEach((key) => {
        const columnId = footerHeadsView[key].id;
        formulaColumnIds.push(columnId);
      });
    }

    await dispatch(fetchAggregateResults(pathname, [footerHeadsView[key].id, ...formulaColumnIds]));
  };

export const updateMultiField =
  (indexs, bodys, records, values, keys = [], heads, pathname) =>
  async (dispatch, getState) => {
    const { footerHeadsView } = getState().stateRecordData;
    const updateRecords = [];
    const columnDataPositions = [];
    for (const i in indexs) {
      const attributes = {};
      for (const idx in records[i]) {
        if (records[i][idx].type === "check_box") {
          const data = [];
          heads[keys[i][idx]].selections.forEach((v) => {
            data.push(v.name);
          });
          values[i][idx] = values[i][idx].filter((i) => data.includes(i));
        } else if (records[i][idx].type === "date" || records[i][idx].type === "datetime") {
          //現状使用されていないため、moment.tzの対応は不要。将来的に使用することになるかもしれないので残す。
          values[i][idx] = values[i][idx] ? moment(values[i][idx]) : "";
        }
        if (records[i][idx].type === "member" && values[i][idx]) {
          attributes[heads[keys[i][idx]].data_position] = values[i][idx].map((value) => value.id);
        } else {
          attributes[heads[keys[i][idx]].data_position] = values[i][idx];
        }
        columnDataPositions.push(heads[keys[i][idx]].data_position);
        dispatch(
          updateValue({
            i: indexs[i],
            val: values[i][idx],
            id: keys[i][idx],
          }),
        );
      }
      updateRecords.push({
        id: bodys[i].id,
        attributes,
      });
    }

    const columnIds = [...new Set(columnDataPositions.map((position) => Number(position.match(/_(\d+)$/)[1])))];
    const formulaColumnKeys = [];

    const { data } = await axios.patch(`${pathname}/dynamic_table_records/batch_update`, {
      dynamic_table_records: updateRecords,
    });
    const datas = data.body;
    for (const i in datas) {
      dispatch(
        insertMultiFormula({
          records: datas[i].records,
          i: indexs[i],
          id: Object.keys(datas[i].records)[0],
          val: Object.values(datas[i].records)[0],
        }),
      );

      formulaColumnKeys.push(Object.keys(datas[i].records));
    }
    const formulaColumnIds = [...new Set(formulaColumnKeys.flat().map((key) => footerHeadsView[key].id))];

    await dispatch(fetchAggregateResults(pathname, [...columnIds, ...formulaColumnIds]));
  };

export const updatePulldownValue =
  (i, body, record, v, key, railsContext, heads, input, position) => async (dispatch) => {
    const log = {
      data_type: record.type,
      position: position,
      once_select: {
        value: record.value,
      },
    };
    dispatch(setEditHistory(log));
    if (record.value === v.name) {
      await dispatch(updateField(i, body, { type: record.type, value: "" }, "", key, heads, railsContext));
    } else {
      await dispatch(updateField(i, body, { type: record.type, value: v.name }, v.name, key, heads, railsContext));
    }
  };

export const updateCheckBoxValue = (i, body, record, v, key, pathname, heads, input, position) => async (dispatch) => {
  const value = record.value || [];
  const flag = value.includes(v.name);

  if (!flag) {
    const log = {
      data_type: record.type,
      position: position,
      once_select: {
        value: value,
      },
    };
    dispatch(setEditHistory(log));
    await dispatch(
      updateField(i, body, { type: record.type, value: [...value, v.name] }, [...value, v.name], key, heads, pathname),
    );
  }
  if (input.current !== null) {
    input.current.focus();
  }
};

// NOTE: 集計結果取得API
export const fetchAggregateResults =
  (pathname, columnIds = null, query = null) =>
  async (dispatch, getState) => {
    const { aggregateResults, footerHeadsView, databaseInfo } = getState().stateRecordData;
    const endpoint = `${pathname}/dynamic_table_views/${databaseInfo.viewId}/grid_views/aggregate`;
    const params = {};
    if (databaseInfo?.isEditable) {
      if (columnIds) {
        params["aggregate_columns"] = columnIds.map((id) => {
          return { dynamic_table_column_id: id };
        });
      }
    } else {
      //NOTE:フィルター検索時,初期読み込み時
      //設定されている集計タイプを取得
      const aggregations = Object.entries(aggregateResults).filter(([key, value]) => {
        return value.aggregate_type !== "none";
      });

      const targetColumns = aggregations.map(([key, value]) => {
        return {
          dynamic_table_column_id: footerHeadsView[key].id,
          aggregate_type: value.aggregate_type,
        };
      });

      params["aggregate_columns"] = targetColumns;
      if (query) params["search_query"] = query;
    }

    const { data } = await axios.post(endpoint, Object.keys(params) && params);
    dispatch(setAggregateResults(data));
  };

export const fetchAggregateResultForChangeView = (pathname) => async (dispatch, getState) => {
  const { databaseInfo } = getState().stateRecordData;
  const endpoint = `${pathname}/dynamic_table_views/${databaseInfo.viewId}/grid_views/aggregate`;

  const { data } = await axios.post(endpoint);
  dispatch(setAggregateResults(data));
};

export const fetchAggregateResultForBrowsingAuth =
  (pathname, aggregationType, columnId, query = null) =>
  async (dispatch, getState) => {
    const { databaseInfo } = getState().stateRecordData;
    const endpoint = `${pathname}/dynamic_table_views/${databaseInfo.viewId}/grid_views/aggregate`;
    const params = {
      aggregate_columns: [
        {
          dynamic_table_column_id: columnId,
          aggregate_type: aggregationType,
        },
      ],
    };
    if (query) {
      params["search_query"] = query;
    }
    const { data } = await axios.post(endpoint, params);
    dispatch(setAggregateResults(data));
  };

export default stateRecordData.reducer;
